import styled, { css } from 'styled-components';

import { white, black } from 'constants/color';

export const StyledPanel = styled.div`
  --whiteColor: ${({ theme }) => theme.whiteColor};
  --borderRadius: ${({ theme }) => theme.borderRadius};
  --primaryColor: ${({ theme }) => theme.primaryColor};

  background-color: ${white};
  border-radius: var(--borderRadius);

  width: 100%;
  height: auto;
  display: flex;
  padding: 5px 10px;

  ${function ({ minHeight }) {
    return (
      minHeight &&
      css`
        min-height: ${minHeight}px;
      `
    );
  }}
`;

export const StyledHeader = styled.h1`
  color: ${black};

  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  margin-left: 10px;
  font-style: normal;
`;

export const ContentWrapper = styled.div``;

export const IconWrapper = styled.div`
  margin-left: auto;
`;
